export const RECEIVE_POPULAR_SEARCHES = 'RECEIVE_POPULAR_SEARCHES';
export const SEARCH_TOGGLE = 'SEARCH_TOGGLE';
export const RECEIVE_AUTOCOMPLETE_PRODUCTS = 'RECEIVE_AUTOCOMPLETE_PRODUCTS';
export const REQUEST_AUTOCOMPLETE_PRODUCTS = 'REQUEST_AUTOCOMPLETE_PRODUCTS';
